












import Vue from 'vue'
import {Getter} from 'vuex-class'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {EtlJobsSection} from '@/models/LobbyDataResponse.model'
import Component from 'vue-class-component'

@Component
export default class EtlJobsSectionComponent extends Vue {

    @Getter('etlJobsSection', StoreNamespace.LOBBY) etlJobsSection!: EtlJobsSection

    private gridColumns: GridColumn[] = []

    mounted(): void {
        this.gridColumns.push({property: 'loadEndDate', header: 'date_and_time'})
        this.gridColumns.push({property: 'etlFileTypeName', header: 'file_type'})
        if (window.innerWidth > 1600) {
            this.gridColumns.push({property: 'etlFileName', header: 'file_name'})
        }
        this.gridColumns.push({property: 'fileRowsCount', header: 'records_in_source_file'})
        this.gridColumns.push({property: 'importedRowsCount', header: 'imported_records'})

        this.gridColumns.forEach((column: GridColumn) => column.hideSorting = true)

        this.$emit('successResults', this.etlJobsSection)
    }
}
